export default {
 LATER:'I’ll do it later',
 CONVERTIBLE:'Generate Convertible Loan Note',
 SAFE:'Generate SAFE',
 NOT_UPGRADE:'Maybe later',
 UPGRADE:'Scale up now'
}